import {
  LIST_VEHICLE,
  CREATE_VEHICLE,
  CHECK_FLEETIFY,
  UPDATE_VEHICLE,
  DELETE_VEHICLE,
  LIST_DRIVER,
  CREATE_DRIVER,
  UPDATE_DRIVER,
  DELETE_DRIVER,
  LIST_BRAND,
  CREATE_BRAND,
  UPDATE_BRAND,
  DELETE_BRAND,
  LIST_MODEL,
  CREATE_MODEL,
  UPDATE_MODEL,
  DELETE_MODEL,
  CREATE_VEHICLE_BULK,
  LIST_DEVICE_TYPE,
  LIST_DEVICE_MODEL,
  LIST_DEVICE_GROUP,
  LIST_VEHICLE_MAINTENANCE,
  CREATE_VEHICLE_MAINTENANCE,
  UPDATE_VEHICLE_MAINTENANCE,
  DELETE_VEHICLE_MAINTENANCE,
  LIST_END_POINTS,
  LIST_VEHICLE_CATEGORY,
  UPDATE_BULK,
  GET_ONE_VEHICLE,
  STATUS_BULK,
  UPDATE_VEHICLE_BULK,
  LIST_VEHICLE_ACCU,
  LIST_VEHICLE_SHIPMENT,
  DETAIL_VEHICLE_SHIPMENT,
  CREATE_VEHICLE_SHIPMENT,
  UPDATE_VEHICLE_SHIPMENT,
  DELETE_VEHICLE_SHIPMENT,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'
//VEHICLE
export const getOneVehicle = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_ONE_VEHICLE + id, config_token)
}

export const getListVehicle = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  let param = REPO.bikinParam(body)
  return axios.get(LIST_VEHICLE + param, config_token)
}

export const postVehicle = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_VEHICLE, data, config_token)
}

export const checkFleetify = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CHECK_FLEETIFY, data, config_token)
}

export const postVehicleBulk = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_VEHICLE_BULK, data, config_token)
}

export const updateVehicle = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_VEHICLE + id, data, config_token)
}

export const updateStatusVehicle = (data, vin) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(STATUS_BULK + vin, data, config_token)
}

export const deleteVehicle = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_VEHICLE + id, config_token)
}

export const takeOutVehicle = (param) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_VEHICLE_MAINTENANCE, param, config_token)
}

//DRIVER
export const getListDriver = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(LIST_DRIVER + param, config_token)
}

export const postDriver = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_DRIVER, data, config_token)
}

export const updateDriver = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_DRIVER + id, data, config_token)
}

export const deleteDriver = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_DRIVER + id, config_token)
}

//BRAND
export const getListBrand = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_BRAND, config_token)
}

export const postBrand = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_BRAND, data, config_token)
}

export const updateBrand = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_BRAND + id, data, config_token)
}

export const deleteBrand = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_BRAND + id, config_token)
}

//MODEL
export const getListModel = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_MODEL, config_token)
}

export const postModel = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_MODEL, data, config_token)
}

export const updateModel = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_MODEL + id, data, config_token)
}

export const deleteModel = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_MODEL + id, config_token)
}

//DEVICE
export const getListDeviceType = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_DEVICE_TYPE, config_token)
}

export const getListDeviceModel = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_DEVICE_MODEL, config_token)
}

export const getListDeviceGroup = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_DEVICE_GROUP, config_token)
}
export const getListEndPoints = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_END_POINTS, config_token)
}

//VEHICLE Category
export const getListVehicleCategory = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_VEHICLE_CATEGORY, config_token)
}

export const getListVehicleAccu = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_VEHICLE_ACCU, config_token)
}

//VEHICLE MAINTENANCE
export const getListVehicleMaintenance = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(LIST_VEHICLE_MAINTENANCE + param, config_token)
}

export const postVehicleMaintenance = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_VEHICLE_MAINTENANCE, data, config_token)
}
export const updateVehicleMaintenance = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_VEHICLE_MAINTENANCE, data, config_token)
}

export const updateVehicleBulk = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_VEHICLE_BULK + id, data, config_token)
}

export const updateVehicleMaintenanceBulk = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(UPDATE_BULK, data, config_token)
}

export const deleteVehicleMaintenance = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_VEHICLE_MAINTENANCE + id, config_token)
}

//Vehicle Shipment

export const getListVehicleShipment = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(LIST_VEHICLE_SHIPMENT + param, config_token)
}

export const getDetailVehicleShipment = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DETAIL_VEHICLE_SHIPMENT + id, config_token)
}

export const postVehicleShipment = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_VEHICLE_SHIPMENT, data, config_token)
}

export const updateVehicleShipment = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_VEHICLE_SHIPMENT + id, data, config_token)
}

export const deleteVehicleShipment = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_VEHICLE_SHIPMENT + id, config_token)
}

